const englishTranslations = require("./en.json");

// Resolves a dotted translationId (e.g. "FILE_MULTIPLE_EMAIL.ERROR_LOADING_EMAILS")
// against the bundled English translations, which are always available synchronously
// regardless of the react-localize-redux store state. Useful as a fallback when a
// translated string is requested before the store has finished initializing.
export function getEnglishTranslation(translationId: string): string | undefined {
    const value = translationId
        .split(".")
        .reduce<any>((current, key) => (current == null ? undefined : current[key]), englishTranslations);
    return typeof value === "string" ? value : undefined;
}
